import { LightState } from './types';

export const lightInitialState: LightState = {
  lights: [],
};
